// Iter57 — shared SEO helpers used by PlanDetail and LandingPage.
// Each helper returns a cleanup fn that restores the previous state so
// pages can safely register on mount and revert on unmount.

export function setMetaTag(attr, key, value) {
  if (value == null || value === "") return null;
  const selector = `meta[${attr}="${key}"]`;
  let el = document.head.querySelector(selector);
  const created = !el;
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  const prev = el.getAttribute("content");
  el.setAttribute("content", String(value));
  return () => {
    if (created) el.parentNode && el.parentNode.removeChild(el);
    else if (prev != null) el.setAttribute("content", prev);
  };
}

export function setLinkTag(rel, href) {
  if (!href) return null;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  const created = !el;
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  const prev = el.getAttribute("href");
  el.setAttribute("href", href);
  return () => {
    if (created) el.parentNode && el.parentNode.removeChild(el);
    else if (prev != null) el.setAttribute("href", prev);
  };
}
